export default {
	subtitle: "Confirm 3DS Credit Card Transaction in Brazil (Deprecated)",
  path: "deprecated_transaction_cc_3ds_challenge_br",
	paragraphs: [
    "When your customer is prompted for an OTP, the transaction you created in the previous step will be held on pending until this step is done. Once that OTP is entered and confirmed, this endpoint needs to be called in the sequence.",
    "If the process is successfully complete, you will have an 'identified' status transaction. Otherwise, it will be canceled. In this case you can check what happened in the 'errors' or 'payment_failed' field.",
    "Note: if you are using the HTML sample page, this part will be done automatically and any errors will be presented on pop-ups."
  ],
  request: {
    method: "POST",
    endpoint: "/transactions/:id/threeds_challenge",
    payload: {
      "code_threeds": "dbe5a61a-836d-45dd-82c1-52d0c5e3c010",
      "validate_token": "jwt"
    },
    responses: {
      "data": {
        "value": "777.00",
        "to_bank_account": {
          "routing_number": null,
          "owner_name": "REARDEN STEEL CO.",
          "owner_document_number": "2348909854385",
          "owner_company": {
            "social_name": "POWER HOME THEATER",
            "id": "f64e512c-1a81-42d9-9ac9-05f369bc98e3",
            "document_type": "tax_id",
            "document_number": "2348909854385"
          },
          "internal": true,
          "intermediary_bank_account": null,
          "id": "1ae24ce1-0a08-4c70-8aaa-c86d89ab32fa",
          "iban": null,
          "flow_type": "cash_in",
          "currency": "USD",
          "branch_number": null,
          "branch_country": null,
          "bank": {
            "swift": null,
            "name": "Internal",
            "id": "6facab8d-573e-44d0-a4bd-ce2600368263",
            "code": "999"
          },
          "account_type": "conta-corrente",
          "account_number": null,
          "aba": null
        },
        "subject_is_receiver": false,
        "subject_id": "9e70a3f2-913d-48c8-9bc2-cf2a23c34ac8",
        "subject": {
          "updated_at": "2022-03-18T12:56:18.662474",
          "status": "approved",
          "social_name": "Gustavo Maia",
          "short_id": "B1951B75",
          "required_clearance_level": 2,
          "references": [],
          "phone_number": "31265489842",
          "net_monthly_average_income": "15400.00",
          "inserted_at": "2021-03-26T19:14:56.053486",
          "id": "9e70a3f2-913d-48c8-9bc2-cf2a23c34ac8",
          "fiscal_country": "Brasil",
          "email": "vbrain1@yahoo.com.br",
          "document_type": "cpf",
          "document_number": "10000000019",
          "clearance_level": 2,
          "birth_date": null,
          "address_street": null,
          "address_state": null,
          "address_postal_code": null,
          "address_number": null,
          "address_country": null,
          "address_complement": null,
          "address_city": null
        },
        "status": "identified",
        "source_name": "Gustavo Maia",
        "source_document_type": "cpf",
        "source_document_number": "10000000019",
        "short_id": "53DE0CB3",
        "meta": null,
        "inserted_at": "2022-03-18T12:56:18.533873",
        "id": "3661d034-7822-4026-999a-0eea110b5d6a",
        "from_credit_card": {
          "status": "tokenized",
          "inserted_at": "2022-03-18T12:56:18.511291",
          "id": "bea67731-6e7c-4abd-938c-1e885bbc08fb"
        },
        "from_bank_account": null,
        "for_exchange": true,
        "exchange_under_request": false,
        "exchange_currency": "USD",
        "estimated_value_until_exchange": false,
        "currency": "BRL",
        "cleared": false,
        "bank_transaction": {
          "wire_id": null,
          "value": "765.35",
          "source_type": "CREDIT CARD",
          "source_name": "Gustavo Maia",
          "source_id": "3661d034-7822-4026-999a-0eea110b5d6a",
          "source_document_type": "cpf",
          "source_document_number": "10000000019",
          "source_description": "PAGAMENTO POR CARTAO",
          "source_branch": null,
          "source_bank": null,
          "source_account": null,
          "movement_date": "2022-03-18",
          "iof_value": null,
          "inserted_at": "2022-03-18T12:56:28.811215",
          "id": "592334f9-5c2a-4e2d-b91c-3221a75f6236",
          "exchanged_value": null,
          "exchange_rate": null,
          "exchange_id": null,
          "exchange_currency": "USD",
          "exchange_approved": false,
          "currency": "BRL"
        }
      }
    }
  },
  parameterPayload: [
    {
			name: "code_threeds",
			type: "string",
			required: true,
			description: "This field is the same one you sent when creating the transaction (threeds.code3DS)"
		},
    {
			name: "validate_token",
			type: "string",
			required: true,
			description: "You will receive this field as an argument in the callback function you sent when creating the library object (new Adiq3ds('ccnum', this_function))"
		},
  ],
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "ID of the transaction created in the previous step"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Deprecated/Transaction/CreditCardBRConfirmation.js